/**
 * Swaps the favicon to favicon-dev.png in development mode.
 *
 * The `.client` suffix ensures this plugin only runs on the client
 * side.
 */
export default defineNuxtPlugin(() => {

  if (process.env.NODE_ENV !== "development") return

  const faviconLink = document.querySelector('link[rel="icon"]')

  switch (true) {
    case faviconLink !== null: {
      // Use VITE_FRONTEND_CLIENT_PATH to support non-root deployment paths
      const frontendClientPath = import.meta.env.VITE_FRONTEND_CLIENT_PATH || '/'

      faviconLink.setAttribute('href', frontendClientPath + 'favicon-dev.png')
    }
  }
})
